<script setup>
// Astra DS · CtaButton — **envoltorio del botón del sistema.**
//
// Figma: los frames `cta` de `Template/MiCuenta-Reset 1240:4964`. Caja de 42 de
// alto, 19 de aire a los lados, la etiqueta en `mono/micro` y la flecha de la
// casa a 12.
//
// 🔴 **El estilo ya no vive aquí: vive en `ButtonDs`**, que desde el 18.09.26 es
// el master. Aquella nota de «no es ButtonDs, aquél es el botón editorial» era
// cierta cuando el master tenía tres variantes; ahora la caja del área es el
// tamaño `area` y las dos formas son `primary` y `ghost`. Esto queda como
// traductor para los siete ficheros del área, que no cambian una línea.
//
// 🔴 **La flecha es `Icon/arrow-forward`, nunca el carácter `→`.** Lo dice la
// descripción del icono en la Library.
import { computed } from "vue";
import ButtonDs from "./ButtonDs.vue";

const props = defineProps({
  label: { type: String, required: true },
  variant: {
    type: String,
    default: "solid",
    validator: (v) => ["solid", "outline"].includes(v),
  },
  wide: { type: Boolean, default: false },
  icono: {
    type: String,
    default: "arrow-forward",
    validator: (v) => ["arrow-forward", "plus"].includes(v),
  },
  type: { type: String, default: "button" },
  disabled: { type: Boolean, default: false },
});

const forma = computed(() => (props.variant === "solid" ? "primary" : "ghost"));
</script>

<template>
  <ButtonDs
    class="cta-btn"
    :class="`cta-btn--${variant}`"
    :label="label"
    :variant="forma"
    size="area"
    :wide="wide"
    :icono="icono"
    :type="type"
    :disabled="disabled"
  />
</template>
